import { Box, Button, FormField, Select, Image, Stack } from "grommet";
import React from "react";
import ThemeViewOld from "./ThemeViewOld";
import axios from "./general/HttpClient";
import { BrowseThemes, GenerateThemes, Theme } from "./ThemeStore";

const ThemesHome = () => {
    const [themes, setThemes] = React.useState([] as Theme[]);
    const listThemes = () => {
        axios.get("/api/themes/browse").then((response) => {
            setThemes(response.data);
        });
    };

    React.useEffect(() => {
        listThemes();
    }, []);

    const [loading, setLoading] = React.useState(false);
    const [message, setMessage] = React.useState("");

    const generateThemes = () => {
        setLoading(true);
        setMessage("Generating Themes...");
        if (selectedTheme.id) {
            GenerateThemes("").then((response) => {
                listThemes();
                setLoading(false);
            });
        }
    };

    const [selectedTheme, setSelectedTheme] = React.useState({} as Theme);

    return (
        <>
            <Box direction="row">
                {loading && <Box>{message}</Box>}
                {!loading && <Button label="Generate Themes" onClick={generateThemes}></Button>}
            </Box>
            <Box align="center" justify="center" direction="row" wrap gap="small">
                {themes.map((theme) => (
                    <ThemeViewOld key={theme.id} theme={theme} onUpdate={() => listThemes()}></ThemeViewOld>
                ))}
            </Box>
        </>
    );
};

export default ThemesHome;
